import { CART_ERROR_KEYS } from 'server/controllers/cart/cartErrorKeys'

/**
 * Trigger Ods Error
 * when the next checkout
 * send the query parameter error
 * with the key checkout-could-not-be-initialized
 */
const hasOrderDraftError = (queryParam: string): boolean =>
  queryParam === CART_ERROR_KEYS.MISSING_ORDER_DRAFT

/**
 * when the next checkout
 * send the query parameter error
 * with the key checkout-error-erx-service-unavailable
 */
const hasErxServiceUnavailableError = (queryParam: string): boolean =>
  queryParam === CART_ERROR_KEYS.ERX_SERVICE_UNAVAILABLE

/**
 * When next checkout sends a query parameter error to
 * indicate a professional customer has medicine(s).
 */
const hasCustomerTypeProfessionalWithMedicineProductError = (
  queryParam: string
): boolean =>
  queryParam === CART_ERROR_KEYS.CUSTOMER_TYPE_PROFESSIONAL_HAS_MEDICINE_PRODUCT

/**
 * When checkout sends a query parameter, indicating that the
 * redpoints reservation has failed.
 */
const hasRedPointsReservationError = (queryParam: string): boolean =>
  queryParam === CART_ERROR_KEYS.REDPOINTS_RESERVATION_FAILED

/**
 * When next checkout sends a query parameter error to
 * indicate a professional customer has marketplace product(s).
 */
const hasCustomerTypeProfessionalWithMarketplaceProductError = (
  queryParam: string
): boolean =>
  queryParam ===
  CART_ERROR_KEYS.CUSTOMER_TYPE_PROFESSIONAL_HAS_MARKETPLACE_PRODUCT

/**
 * When next checkout sends a query parameter error to
 * indicate a professional customer has medicine(s) and marketplace product(s).
 */
const hasCustomerTypeProfessionalWithMedicineAndMarketplaceProductError = (
  queryParam: string
): boolean =>
  queryParam ===
  CART_ERROR_KEYS.CUSTOMER_TYPE_PROFESSIONAL_HAS_MEDICINE_AND_MARKETPLACE_PRODUCT

export {
  hasOrderDraftError,
  hasErxServiceUnavailableError,
  hasCustomerTypeProfessionalWithMarketplaceProductError,
  hasCustomerTypeProfessionalWithMedicineAndMarketplaceProductError,
  hasCustomerTypeProfessionalWithMedicineProductError,
  hasRedPointsReservationError,
}
